module.exports = __webpack_public_path__ + "img/fors.c5455f32.svg";